import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  HOSTING_DC_ADDRESS,
  HOSTING_NAME,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  PROCESSING_START_DATE,
  SITES_LABEL,
  TERMS_PATH,
} from '../legal/operator';

export default function ConsentPage() {
  return (
    <LegalDoc title="Согласие на обработку персональных данных">
      <p>
        Настоящее согласие — отдельный документ. Оно не является частью{' '}
        <Link to={TERMS_PATH}>пользовательского соглашения</Link>
        {' '}и не является частью{' '}
        <Link to={OFERTA_PATH}>договора-оферты</Link>
        . Текст политики:{' '}
        <Link to="/privacy">Политика обработки персональных данных</Link>.
      </p>
      <p>
        Редакция: {POLICY_DATE} Обработка с согласия начинается не ранее{' '}
        {PROCESSING_START_DATE}
      </p>

      <h2>1. Кто даёт согласие</h2>
      <p>
        Субъект персональных данных — тот, кто ставит отметку в форме регистрации
        на Сайте ({SITES_LABEL}) и передаёт свои данные: ученик с 14 лет либо
        родитель (законный представитель). Субъект идентифицируется по сведениям
        формы (имя, логин, email).
      </p>
      <p>
        Ученик, которому уже есть 14 лет, даёт это согласие сам. Согласие родителя
        на обработку персональных данных такого ученика не требуется.
      </p>
      <p>
        Если ученику нет 14 лет, он на Сайте сам согласие не даёт. Согласие на его
        данные даёт родитель.
      </p>
      <p>
        Договор на занятия — отдельный документ, не этот текст. Его заключает
        родитель, принимая{' '}
        <Link to={OFERTA_PATH}>договор-оферту</Link>. Отметка ученика в форме
        регистрации этот договор не заключает. Доступ к Сайту оформляется{' '}
        <Link to={TERMS_PATH}>пользовательским соглашением</Link>, оно тоже
        отмечается отдельно.
      </p>

      <h2 id="child">Согласие родителя на данные ребёнка</h2>
      <p>
        Родитель с аккаунтом на Сайте может отдельно согласиться на обработку
        персональных данных ребёнка и передать ему ссылку на регистрацию. Согласие
        даётся до создания учётной записи ребёнка и относится к имени, логину,
        адресу электронной почты и учебным сведениям, которые ребёнок укажет по
        этой ссылке и дальше на Сайте.
      </p>
      <p>
        Так регистрируется в том числе ребёнок младше 14 лет: сам он согласие дать
        не может, его даёт родитель. Для аккаунта ребёнка родитель также принимает
        пользовательское соглашение. Ребёнок с 14 лет по-прежнему может
        зарегистрироваться сам и дать согласие лично; ссылка родителя этот путь
        не отменяет.
      </p>

      <h2>2. Оператор</h2>
      <ul>
        <li>{OPERATOR_NAME}</li>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Email:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>

      <h2>3. На что даётся это согласие</h2>
      <p>
        Согласие даётся на цель «подготовка, заключение и исполнение
        гражданско-правового договора» в той части, для которой договора с самим
        учеником недостаточно:
      </p>
      <ol>
        <li>
          Учебные сведения: класс, школа, город, телефон, аватар, решения задач,
          журнал, присутствие на странице занятия, сообщения на Сайте, участие в
          голосовой связи через Яндекс&nbsp;Телемост или «Макс».
        </li>
        <li>
          Анкета, если человек её заполнил, включая ответ о финансовых возможностях
          семьи. Анкету можно не заполнять, без неё регистрация возможна.
        </li>
      </ol>

      <h2>4. Что этим согласием не оформляется</h2>
      <p>
        Имя, адрес электронной почты, логин и хеш пароля для доступа к Сайту
        обрабатываются по пользовательскому соглашению, которое отмечается отдельно.
      </p>
      <p>
        Оплата обрабатывается, только если человек сам платит, по договору и по
        закону о расчётах.
      </p>
      <p>
        IP-адрес, журналы запросов и cookie сессии обрабатываются у всех
        посетителей для работы и безопасности Сайта.
      </p>
      <p>
        Яндекс.Метрика и Вебвизор включаются только отдельным согласием в баннере
        cookie и не являются частью настоящего документа.
      </p>

      <h2>5. Действия и способы</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление) получателям
        из Политики, блокирование, обезличивание, удаление, уничтожение.
        Обработка автоматизированная, с передачей по сети Интернет, база данных на
        территории РФ ({HOSTING_NAME}, {HOSTING_DC_ADDRESS}).
      </p>
      <p>
        Получатели в объёме, нужном для цели: хостинг {HOSTING_NAME}, почтовый
        сервис, Яндекс&nbsp;Телемост при занятии через этот сервис, «Макс» или
        ВКонтакте, если указан этот канал. Платёжный сервис получает данные
        платежа только при оплате. Яндекс.Метрика получает данные только после
        согласия в баннере.
      </p>

      <h2>6. Срок и отзыв</h2>
      <p>
        Согласие действует с момента отметки в форме до отзыва либо до удаления
        учётной записи, если закон не требует хранить данные дольше (расчёты).
      </p>
      <p>
        Отозвать согласие и потребовать удаление можно письмом на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        {' '}или запросом удаления аккаунта в профиле. Запрос по почте обрабатывается
        в срок не позднее 10 рабочих дней. Отзыв не затрагивает обработку, которая
        уже выполнена, исполнение заключённого договора и срок хранения сведений
        об оплате по закону. Согласие на Метрику и Вебвизор отзывается через
        «Настройки cookie» в подвале.
      </p>

      <h2>7. Добровольность</h2>
      <p>
        Согласие даётся свободно, своей волей и в своём интересе. Без него нельзя
        вести учебные сведения ученика: он не сторона оферты на занятия. Доступ
        к Сайту как к кабинету опирается на пользовательское соглашение.
      </p>
    </LegalDoc>
  );
}
